export const API_URL: any = {};

API_URL['agencyUrl'] = '/agency';
API_URL['projectCategoriesUrl'] = '/filters/category';
API_URL['changeStatus'] = API_URL['agencyUrl'] + '/%s/status';
API_URL['userChangeEmail'] ='/user/change-email'
/**
 * Profile urls
 */
API_URL['profile'] = '/profile';
API_URL['profileFreelancer'] = API_URL['profile'] + '/freelancer';
API_URL['profileVendor'] = API_URL['profile'] + '/vendor';
API_URL['profileAgency'] = API_URL['profile'] + '/agency';
API_URL['profileIndividual'] = API_URL['profile'] + '/individual';

// Employess module urls
API_URL['employees'] = '/employee';
// tenant-features API
API_URL['tenant_features']='/tenant-features';
// Roles module urls
API_URL['roles'] = '/role';
API_URL['fieldAccess'] = API_URL['roles'] + '/%s/field-access';
API_URL['rolesParent'] = API_URL['roles'] + '/parent';
API_URL['rolesAccess'] = API_URL['roles'] + '/%s/access';
API_URL['filterRolesFreelancer'] = '/filters/roles/freelancer';
API_URL['samplePermissions'] = 'assets/data/roles-advanced-settings.json';

// Talent module full paths
API_URL['talent'] = '/talent';
API_URL['individual'] = '/individual';
API_URL['agency'] = '/agency';
API_URL['individualFilterList'] = API_URL['individual'] + '/filters';
API_URL['agencyFilterList'] = API_URL['agency'] + '/filters';
API_URL['activateAgency'] = '/agency/activate';
API_URL['activateIndividual'] = '/individual/activate';

//Talent PO urls
API_URL['talentPO'] = '/talent-purchase-order';
API_URL['talentPOBudgetLines'] = API_URL['talentPO'] + '/budget-line';
API_URL['talentPOCategory'] = API_URL['talentPO'] + '/category';
API_URL['talentPOService'] = API_URL['talentPO'] + '/services';

API_URL['talentPOMedia'] = API_URL['talentPO'] + '/media';
API_URL['talentPORole'] = API_URL['talentPO'] + '/role';
API_URL['talentPOIndividual'] = API_URL['talentPO'] + '/individual';
API_URL['talentPOAgency'] = API_URL['talentPO'] + '/agency';
API_URL['talentPOTerritory'] = API_URL['talentPO'] + '/territory';
/** Freelancer module API url's */
API_URL['freelancerUrl'] = 'freelancer';
API_URL['freelancerStepOneUrl'] = API_URL['freelancerUrl'] + '/activate';
API_URL['freelancerContractApprovalUrl'] = API_URL['freelancerUrl'] + '/contract-approval';
API_URL['freelancerContractRejectionUrl'] = API_URL['freelancerUrl'] + '/contract-rejection';

/** Vendor module API url's */
API_URL['vendorUrl'] = 'vendor';
API_URL['user'] = '/user';
API_URL['vendorContractApprovalUrl'] = API_URL['vendorUrl'] + '/contract-approval';
API_URL['vendorContractRejectionUrl'] = API_URL['vendorUrl'] + '/contract-rejection';
API_URL['vendorActivateURL'] = API_URL['vendorUrl'] + '/activate';
API_URL['stepThreeVendorContractUrl'] = API_URL['vendorUrl'] + '/contract';
API_URL['contractDownload'] = API_URL['user'] + '/contract-download';
API_URL['contractAcceptTerm'] = API_URL['user'] + '/contract-accept-term';
/** Login module user information API url's */

API_URL['userInfoUrl'] = 'user/user-info';
 
API_URL['projectsUrl'] = 'projects';
API_URL['projectsyncUrl'] = API_URL['projectsUrl'] + '/sync';

/**Budget URL */
API_URL['budgetListUrl'] = API_URL['projectsUrl'] + '/%s' + '/budgets';
API_URL['workingUrl'] = '/project-setting/working';

/** Location module API url's */
API_URL['locationCategoriesUrl'] = 'location-categories';
API_URL['manageLocationCategoriesUrl'] = 'location-categories' + '/%s';
API_URL['locationUrl'] = '/location';
API_URL['addLocationNameUrl'] = API_URL['locationUrl'] + '/add';
API_URL['manageLocationUrl'] = API_URL['locationUrl'] + '/%s';
API_URL['locationStatesUrl'] = API_URL['locationUrl'] + '/states';
API_URL['locationCitiesUrl'] = API_URL['locationUrl'] + '/cities';
API_URL['imagesUrl'] = API_URL['manageLocationUrl'] + '/images';
API_URL['locationTagsUrl'] = API_URL['locationUrl'] + '/tags';
API_URL['deleteLocationUrl'] = API_URL['locationUrl'] + '/%s';
API_URL['images1Url'] = '/location-images';
API_URL['scouterLocationAccessListUrl'] = '/location-access';
API_URL['scouterLocationAccessUrl'] = API_URL['scouterLocationAccessListUrl'] + '/%s';
API_URL['reviewListUrl'] = API_URL['locationUrl'] + '/review-search';
API_URL['reviewUrl'] = API_URL['locationUrl'] + '/%s/review';
API_URL['locationZip'] = '/location-zip';
API_URL['zipProjectList'] = API_URL['locationZip'] + '/projects';
API_URL['reviewDataLimitUrl'] = API_URL['locationUrl'] + '/%s' + '/tags';

/**Projects URL */

API_URL['purchaseOrderUrl'] = '/purchase-order';
API_URL['advance'] = 'advance';
API_URL['cancelPO'] = API_URL['purchaseOrderUrl'] + '/%s' + '/cancel';
API_URL['approvePo'] = API_URL['purchaseOrderUrl'] + '/%s' + '/approve';
API_URL['rejectPo'] = API_URL['purchaseOrderUrl'] + '/%s' + '/reject';
API_URL['onhold'] = API_URL['purchaseOrderUrl'] + '/%s' + '/pending';
API_URL['approveAdvancePayment'] = API_URL['purchaseOrderUrl'] + '/%s' + '/payment/approve';
API_URL['rejectAdvancePayment'] = API_URL['purchaseOrderUrl'] + '/%s' + '/payment/reject';
API_URL['defaultValueURL'] = API_URL['purchaseOrderUrl'] + '/default-value';
API_URL['poAdvance'] = API_URL['purchaseOrderUrl'] + '/advance';
API_URL['poVendorUrl'] = API_URL['purchaseOrderUrl'] + '/vendor';
API_URL['poFreelancerUrl'] = API_URL['purchaseOrderUrl'] + '/freelancer';
API_URL['poLocationUrl'] = API_URL['purchaseOrderUrl'] + '/location';
API_URL['poSettlementUrl'] = '/posettlement';
API_URL['onholdSettlement'] = API_URL['poSettlementUrl'] + '/%s' + '/pending';
API_URL['approveSettlement'] = API_URL['poSettlementUrl'] + '/%s' + '/approve';
API_URL['rejectSettlement'] = API_URL['poSettlementUrl'] + '/%s' + '/reject';
API_URL['poSettlementCancelUrl'] = API_URL['poSettlementUrl'] + '/%s' + '/cancel';
API_URL['purchaseOrderUrlContractAcceptance'] = API_URL['purchaseOrderUrl'] + '/project-contract-acceptance';
API_URL['purchaseOrderUrlPALAcceptance'] = API_URL['projectsUrl'] + '/%s/project-assignment-letter';
API_URL['getAverageApprovalAgeUrl'] = 'average-approval';

API_URL['prep'] = '/prep';
API_URL['prepSchedule'] = API_URL['prep'] + '/schedule';
API_URL['dailyScheduleHistory'] = API_URL['prepSchedule'] + '/history';
API_URL['prepTravelMovement'] = API_URL['prep'] + '/travel-movement'
API_URL['travelMovementHistory'] = API_URL['prepTravelMovement'] + '/history';


API_URL['prepDirectorsScout'] = API_URL['prep'] + '/director-scout';
API_URL['prepDirectorsScoutHistory'] = API_URL['prepDirectorsScout'] + '/history';
API_URL['prepDirectorsDriverList'] = API_URL['prep'] + '/director-scout/filters/driver'
/** common/filter API url's */
API_URL['filters'] = '/filters';
API_URL['companyUrl'] = API_URL['filters'] + '/company';
API_URL['budgetTypesUrl'] = API_URL['filters'] + '/budget-types';
API_URL['projectBudgetTypes'] = API_URL['filters'] + '/project-budget-types/%s';
API_URL['paymentProjects'] = API_URL['filters'] + '/payment-projects';
API_URL['budgetLine'] = API_URL['filters'] + '/po-budget-line';
API_URL['poVendors'] = API_URL['filters'] + '/purchase-order-vendor';
API_URL['reqByValues'] = API_URL['filters'] + '/requested-by/vendor';
API_URL['poFilterFreelancerUrl'] = API_URL['filters'] + '/purchase-order-freelancer';
API_URL['poProductionCoordinatorUrl'] = API_URL['filters'] + '/purchase-order-production-co-ordinator';
API_URL['poProjects'] = API_URL['filters'] + '/po-projects';
API_URL['suppliers'] = API_URL['filters'] + '/freelancer-vendor';
API_URL['currency'] = API_URL['filters'] + '/currency';
API_URL['file'] = '/file';
API_URL['projectSupplierListUrl'] = '/filters/suppliers';
API_URL['projectsListUrl'] = '/filters/projects';


/** Master PO module API urls */
API_URL['masterPO'] = API_URL['purchaseOrderUrl'] + '/master';
API_URL['masterPOExcel'] = API_URL['masterPO'] + '/export';

/** Master Invoice module API urls */
API_URL['masterInvoice'] = '/invoices/master';
API_URL['masterInvoiceExcel'] = API_URL['masterInvoice'] + '/export';

/** Payments module API urls */
API_URL['payments'] = '/payments';

API_URL['paymentsStatus'] = API_URL['payments'] + '/status';

API_URL['masterPayment'] = API_URL['payments'] + '/master';
API_URL['managePayment'] = API_URL['payments'] + '/%s';
API_URL['managePaymentDetails'] = API_URL['payments'] + '/%s/details';
API_URL['paymentHistory'] = API_URL['payments'] + '/payment-history';
API_URL['paymentInvoices'] = API_URL['payments'] + '/invoices/%s';

API_URL['paymentTotal'] = API_URL['payments'] + '/payments-sum';
API_URL['masterPaymentTotal'] = API_URL['paymentTotal'] + '/master';

API_URL['schedulePayment'] = API_URL['payments'] + '/%s/schedule';
API_URL['makePayment'] = API_URL['payments'] + '/%s/pay';
API_URL['cancelPayment'] = API_URL['payments'] + '/%s/cancel';
API_URL['reschedulePayment'] = API_URL['payments'] + '/%s/re-schedule';

API_URL['approvePayment'] = API_URL['payments'] + '/%s/approve';
API_URL['rejectPayment'] = API_URL['payments'] + '/%s/reject';
API_URL['pendingPayment'] = API_URL['payments'] + '/%s/pending';

API_URL['paymentsExcel'] = API_URL['payments'] + '/export';

/** Bidding module API urls */
API_URL['bids'] = '/projects';
API_URL['projectInputs'] = '/projectInputs';
API_URL['passes'] = '/passes';
API_URL['passesInfo'] = API_URL['passes'] + '/info' + '/%s';
API_URL['pipedrive'] = '/pipedrive';
API_URL['organizations'] = API_URL['pipedrive'] + '/organizations';
API_URL['contactPersons'] = API_URL['pipedrive'] + '/persons';
API_URL['leads'] = '/leads';
API_URL['manageLead'] = API_URL['leads'] + '/%s';
API_URL['masterConfiguration'] = '/master-configuration';
API_URL['projectMasterConfiguration'] = '/project-master-configuration';
API_URL['masterConfigurationApprovalHierarchy'] = '/master-configuration/approval-hierarchy';
API_URL['projectMasterConfigurationApprovalHierarchy'] = '/project-master-configuration/approval-hierarchy';
API_URL['filterPass'] = API_URL['filters'] + '/all-pass';
API_URL['preBidRoles'] = API_URL['filters'] + '/roles/prebid';
API_URL['preBidUsers'] = API_URL['filters'] + '/users';
API_URL['convertToProject'] = API_URL['bids'] + '/%s' + '/convert' + '/%s';
API_URL['checkProjectExistsOrNot'] = API_URL['bids'] + '/check';
API_URL['projectInputsMedia'] = API_URL['projectInputs'] + '/media';
API_URL['projectInputsTerritory'] = API_URL['projectInputs'] + '/territory';
API_URL['projectInputsVehicle'] = API_URL['projectInputs'] + '/vehicle';
API_URL['filterDeals'] = API_URL['filters'] + '/deals';
API_URL['exportBidData'] = API_URL['projectInputs'] + '/%s/bid-export'

/** Invoice module API urls */
API_URL['managePurchaseOrderUrl'] = '/purchase-order/%s';
API_URL['invoiceUrl'] = '/invoices';
API_URL['manageInvoiceUrl'] = API_URL['invoiceUrl'] + '/%s';
API_URL['uploadattachment'] = API_URL['invoiceUrl'] + '/upload-attachments' + '/%s';
API_URL['invoicesHistoryUrl'] = API_URL['invoiceUrl'] + '/history';
API_URL['removeInvoiceUrl'] = API_URL['invoiceUrl'] + '/%s' + '/cancel';
API_URL['paymentsUrl'] = '/payments';
API_URL['approveInvoiceUrl'] = API_URL['invoiceUrl'] + '/%s' + '/approve';
API_URL['rejectInvoiceUrl'] = API_URL['invoiceUrl'] + '/%s' + '/reject';
API_URL['onHoldInvoiceUrl'] = API_URL['invoiceUrl'] + '/%s' + '/pending';
API_URL['filterPermitType'] = API_URL['filters'] + '/project/%s/permitType';


/** view po module API url's */
API_URL['viewPO'] = API_URL['purchaseOrderUrl'] + '/view';
API_URL['downloadPo'] = API_URL['purchaseOrderUrl'] + '/generate-pdf';

/** view invoice module API url's */
API_URL['downloadInvoice'] = API_URL['invoiceUrl'] + '/generate-pdf';

API_URL['getBeneficiaryRelations'] = '/freelancer/relations';

/** Hospitality module API urls */
API_URL['hospitality'] = '/hospitality';
API_URL['getNationality'] = API_URL['hospitality'] + '/filter/nationality';
API_URL['getHeadOfDepartments'] = API_URL['hospitality'] + '/filter/head-department';
API_URL['getManagers'] = API_URL['hospitality'] + '/filter/manager';
API_URL['getHotels'] = API_URL['hospitality'] + '/filter/hotels';
API_URL['getLiftProducers'] = API_URL['hospitality'] + '/filter/lift-producer/%s';
API_URL['getGifts'] = API_URL['hospitality'] + '/filter/gifts';
API_URL['getChaperone'] = API_URL['hospitality'] + '/filter/chaperone';
API_URL['getDesignation'] = API_URL['hospitality'] + '/filter/designation';
API_URL['getTransports'] = API_URL['hospitality'] + '/filter/transport';
API_URL['getTransportProviders'] = API_URL['hospitality'] + '/filter/transport-provider';

API_URL['updateHospitality'] = API_URL['hospitality'] + '/%s';
API_URL['getHospitalityByProjectId'] = API_URL['hospitality'] + '/%s';
API_URL['addHospitality'] = API_URL['hospitality'];
API_URL['getRestaurants'] = API_URL['hospitality'] + '/filter/restaurants';
API_URL['notifyChaperone'] = API_URL['hospitality'] + '/notify-chaperone/%s';


/** Hospitality Expenses module API urls */
API_URL['expenses'] = '/hospitality-expenses';
API_URL['getExpensesById'] = API_URL['expenses'] + '/%s';
API_URL['getExpenseCategories'] = API_URL['expenses'] + '/filter/category';
API_URL['getExpenseGuests'] = API_URL['expenses'] + '/filter/guests';
API_URL['getExpenseModes'] = API_URL['expenses'] + '/filter/modes';
API_URL['getExpensePlaces'] = API_URL['expenses'] + '/filter/places';


/** Reports module API urls */
API_URL['reports'] = '/hospitality-reports';

/**
 * Report Module API urls
 */
API_URL['reportsProfile'] = API_URL['reports'] + '/profile';
API_URL['reportsProfileGuests'] = '/hospitality-expenses/filter/guests';
API_URL['reportsProfileDesignation'] = API_URL['hospitality'] + '/filter/designation';


/**
 * Activity Module API urls
 */
API_URL['reportsActivity'] = API_URL['reports'] + '/activities';
API_URL['getReportActivityById'] = API_URL['reportsActivity'] + '/%s';
API_URL['deleteReportActivity'] = API_URL['reportsActivity'] + '/%s';
API_URL['activityLocations'] = API_URL['reports'] + '/filter/activity-location';
API_URL['activityCategories'] = API_URL['reports'] + '/filter/activity-category';

/** Feedback module API urls */
API_URL['reportsFeedback'] = API_URL['reports'] + '/feedback';
API_URL['updateFeedback'] = API_URL['reports'] + '/feedback/%s';
API_URL['getReportCategories'] = API_URL['reports'] + '/filter/activity-category';
API_URL['getFeedbackByProjectId'] = API_URL['reports'] + '/feedback/%s';
API_URL['getHospitalityCategories'] = '/hospitality-expenses/filter/category';

/** Improvements module API urls */
API_URL['reportsImprovements'] = API_URL['reports'] + '/improvements';
API_URL['updateImprovements'] = API_URL['reports'] + '/improvements/%s';
API_URL['getImprovementsByProjectId'] = API_URL['reports'] + '/improvements/%s';


/** Dashboard module API urls */
API_URL['dashboards'] = '/dashboards';
API_URL['getPurchanseOrderCounts'] = API_URL['dashboards'] + '/counts/purchase-orders';
API_URL['getPaymentOrderCounts'] = API_URL['dashboards'] + '/counts/payment-orders';
API_URL['getPaymentsCounts'] = API_URL['dashboards'] + '/counts/payments';
API_URL['getPurchaseOrdersLineGraphDetails'] = API_URL['dashboards'] + '/charts/line/purchase-orders';
API_URL['getPaymentOrdersLineGraphDetails'] = API_URL['dashboards'] + '/charts/line/payment-orders';
API_URL['getPaymentsLineGraphDetails'] = API_URL['dashboards'] + '/charts/line/payments';
API_URL['getPurchaseOrdersPieChartDetails'] = API_URL['dashboards'] + '/chart/pie/purchase-orders';
API_URL['getPaymentOrdersPieChartDetails'] = API_URL['dashboards'] + '/chart/pie/payment-orders';
API_URL['getPaymentsPieChartDetails'] = API_URL['dashboards'] + '/chart/pie/payments';
API_URL['getUserWidgetDetails'] = API_URL['dashboards'] + '/users/widgets';

API_URL['getUsersPurchaseOrdersLineGraphDetails'] = API_URL['dashboards'] + '/charts/line/users/purchase-orders';
API_URL['getUserPaymentOrdersLineGraphDetails'] = API_URL['dashboards'] + '/charts/line/users/payment-orders';
API_URL['getUserPaymentsLineGraphDetails'] = API_URL['dashboards'] + '/charts/line/users/payments';

/** Casting module API urls */
API_URL['casting'] = '/casting';
API_URL['getCastingUserById'] = API_URL['casting'];
API_URL['getCastingList'] = API_URL['casting'];
API_URL['updateCastingUserDetails'] = API_URL['casting'];
API_URL['getModelAgenciesList'] = API_URL['casting'] + '/filter/model-agency';
API_URL['getProfessionsList'] = API_URL['casting'] + '/filter/profession';
API_URL['getRasgosGeneralesList'] = API_URL['casting'] + '/filter/rasgos-fisicos-generales';
API_URL['getColorDePielList'] = API_URL['casting'] + '/filter/color-de-piel';
API_URL['getColorDeCabelloList'] = API_URL['casting'] + '/filter/color-de-cabello';
API_URL['getTipoDeCabelloList'] = API_URL['casting'] + '/filter/tipo-de-cabello';
API_URL['getColorDeOjosList'] = API_URL['casting'] + '/filter/color-de-ojos';
API_URL['getNationalityList'] = API_URL['casting'] + '/filter/nationality';
API_URL['getTagsList'] = API_URL['casting'] + '/filter/tags';
API_URL['addTagItem'] = API_URL['casting'] + '/tags';
API_URL['activateCasting'] = API_URL['casting'] + '/activate';
API_URL['changeCastingStatus'] = API_URL['casting'];
API_URL['getCastingUserProfile'] = '/profile/casting';
API_URL['updateCastingProfile'] = '/profile/casting';
API_URL['getComplexionList'] = 'casting/filter/complexion';
API_URL['castingImageUpload'] = '/profile-image/upload'

API_URL['logout'] = 'sessions/logout';

/** Client master module */
API_URL['getClientMasterListing'] = '/clients',
    API_URL['addClient'] = '/clients',
    API_URL['updateClient'] = '/clients/%s'
API_URL['changeClientStatus'] = '/clients/%s/status';

API_URL['getPolicy'] = '/privacy-policy';
API_URL['contractRenew'] = '/user/contract-renew'

/** Verify Budget */
API_URL['verifyBudget'] = 'projects/aicp-verify';
API_URL['verifyNewCorportateBudget'] = '/projects/aicp-verify/entertainment';

API_URL['aicpExportExcel'] = '/projects/%s/budgets/%s/aicp-download';

API_URL['exportFreelancers'] = '/freelancer/export';
API_URL['exportVendors'] = '/vendor/export';
API_URL['exportAgency'] = '/agency/export';
API_URL['exportIndividual'] = '/individual/export'

/* PO Dashboard */
API_URL['approverList'] = API_URL['dashboards'] + '/po/approvers/list';
API_URL['activeProjectList'] = API_URL['dashboards'] + '/po/project-wise-details';
API_URL['statusWiseDetails'] = API_URL['dashboards'] + '/po/status-wise-details';
API_URL['tierWiseDetails'] = API_URL['dashboards'] + '/po/tier-wise-details';
API_URL['approverDetails'] = API_URL['dashboards'] + '/po/approver-wise-details';
API_URL['chartDetails'] = API_URL['dashboards'] + '/po';

/* Master Settlement */
API_URL['settlement'] = 'posettlement/master';
API_URL['exportSettlement'] = '/posettlement/master/export';
API_URL['cancelSettlement'] = API_URL['poSettlementUrl'] + '/%s' + '/cancel';

API_URL['vendorService'] = 'filters/vendor-services';
API_URL['contractPreview'] = '/user/contract-content';

API_URL['settlementExport'] = 'posettlement/export-zip';
API_URL['exportPayment'] = '/payments/export-zip';
API_URL['moveToDraft'] = '/move-to-draft';
API_URL['notification'] = '/dashboard-notifications';


// WEBPACK FOOTER //
// ./src/app/config/api.config.ts